import { SetStateAction, useState } from 'react'
import { Input } from '../ui/Input'
import { Button } from '../ui/Button'
import { toast, ToastContainer } from 'react-toastify'
import logo from '../../logo.png'
import { useNavigate } from 'react-router-dom'
import { useLoginUser } from '../../hooks/db/useLogin'

export default function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const { forgotPasswordUser } = useLoginUser()
  const navigate = useNavigate()

  const handleSubmit = async () => {
    if(!email) {
      setError('Email is required')
      return
    }
    setLoading(true)
    setError('')
    try {
        // Save user details to Firestore
        const result = await forgotPasswordUser({
            email: email,
        })
        
        if (result.success) {
            setSent(true)
            setEmail('') // Clear the email input field
            toast.success(result.message, {
                position: "top-center",
            })
            setTimeout(() => {
              navigate('/user-login')
            }, 2000)

        } else {
            console.log("Email not found");
            toast.error("Email not found", {
                position: "bottom-center",
            })
            setLoading(false)
            setEmail('')
            return
        }

    } catch (error) {
        if (error instanceof Error) {
            console.log(error.message)
            toast.error(error.message, {
                position: "bottom-center",
            })
            setLoading(false)
            setEmail('')
        } else {
            setLoading(false)
            console.log("An unknown error occurred")
        }
        
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 px-4">
      <ToastContainer />
      <div className="w-full max-w-md p-6 bg-white dark:bg-gray-800 rounded-xl shadow-md">
        {sent ? (
          <div className="text-center">
            <h2 className="text-xl font-semibold mb-2 text-green-600">Email Sent!</h2>
            <p className="text-sm text-gray-600 dark:text-gray-300">
              Please check your inbox for the password reset link.
            </p>
          </div>
        ) : (
          <form
            onSubmit={(e) => {
              e.preventDefault()
              handleSubmit()
            }}
          >
            <div className="flex justify-center mb-4">
                <img src={logo} alt="Company Logo" className="h-18" />
            </div>
            <h2 className="text-2xl font-bold mb-4 text-center text-gray-800 dark:text-white">Forgot Password</h2>

            <div className="mb-4">
              <Input
                id="email"
                type="email"
                placeholder="you@example.com"
                value={email}
                required
                onChange={(e: { target: { value: SetStateAction<string> } }) => setEmail(e.target.value)}
              />
            </div>

            {error && <p className="text-red-600 text-sm mb-3">{error}</p>}

            <button
              type="submit"
              disabled={loading}
              className={`w-full btnLong bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 transition duration-300` + (loading ? ' opacity-50 cursor-not-allowed' : '')}
            >
              Submit
            </button>
          </form>
        )}
      </div>
    </div>
  )
}

  